import { useMemo, useState } from 'react'

interface ArrowUpProps extends React.SVGProps<SVGSVGElement> {
  size?: number
  color?: string
  disabled?: boolean
}

export const ArrowUpSVG = ({
  size = 20,
  color,
  disabled = false,
  style,
  className = '',
  onClick,
  onMouseEnter: onMouseEnterProp,
  onMouseLeave: onMouseLeaveProp,
}: ArrowUpProps) => {
  const [isHovered, setIsHovered] = useState(false)

  const fill = useMemo(() => {
    if (color) {
      return color
    }
    return isHovered ? 'black' : 'gray'
  }, [isHovered, color])

  const handleMouseEnter = (e: React.MouseEvent<SVGSVGElement>) => {
    setIsHovered(true)
    onMouseEnterProp?.(e)
  }

  const handleMouseLeave = (e: React.MouseEvent<SVGSVGElement>) => {
    setIsHovered(false)
    onMouseLeaveProp?.(e)
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={style}
      className={`${className} ${disabled ? 'opacity-50' : 'opacity-100'}`}
      onClick={onClick}
    >
      <path
        d="M7.99999 6.22573C7.92393 6.22573 7.85021 6.23855 7.77884 6.26419C7.70748 6.28984 7.6406 6.33385 7.57821 6.39624L4.57179 9.40264C4.47522 9.49922 4.42864 9.6146 4.43206 9.74879C4.43547 9.88298 4.48547 9.99836 4.58206 10.0949C4.67864 10.1915 4.79573 10.2398 4.93333 10.2398C5.07093 10.2398 5.18802 10.1915 5.28459 10.0949L7.99999 7.37954L10.7256 10.1052C10.8222 10.2018 10.9376 10.2501 11.0718 10.2501C11.206 10.2501 11.3213 10.2018 11.4179 10.1052C11.5145 10.0086 11.5628 9.89152 11.5628 9.75392C11.5628 9.61631 11.5145 9.49756 11.4179 9.39839L8.42178 6.39624C8.35939 6.33385 8.29358 6.28984 8.22434 6.26419C8.15512 6.23855 8.08034 6.22573 7.99999 6.22573Z"
        fill={fill}
      />
    </svg>
  )
}
